import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ExportLoanDocsComponent } from './components/export-loan-docs.component';

const routes: Routes = [
  {
    path: '',
    component: ExportLoanDocsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ExportLoanDocsRoutingModule { }
